export async function copyToClipboard(text: string) {
    try {
        await navigator.clipboard.writeText(text)
        return 'Texto copiado!'
    } catch (err) {
        console.error('Error copying text to clipboard:', err)
        return 'Erro ao tentar copiar!'
    }
}
